/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import CreateTutorialForm from '../forms/CreateTutorialForm';
// eslint-disable-next-line no-unused-vars
import axios from 'axios';

const CreateTutorialModal = ({ show, handleClose }) => {
  const [titulo, setTitulo] = useState('');
  const [file, setFile] = useState(null);
  const [date, setDate] = useState(new Date());

  const handleSubmit = () => {
    if (!titulo || !file) {
      alert('Ambos campos son requeridos.');
      return;
    }

    const formData = new FormData();
    formData.append('title', titulo);
    formData.append('file', file);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Crear Nuevo PDF</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <CreateTutorialForm
          titulo={titulo}
          setTitulo={setTitulo}
          setFile={setFile}
          setDate={setDate}
          date={date}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Crear PDF
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateTutorialModal;
